module.exports = __webpack_public_path__ + "img/banner_doctor.482da50c.png";